module.exports = __webpack_public_path__ + "static/media/lcs_logo.2306a2b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/lcs_logo.png
// module id = 1793
// module chunks = 0 1